/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import ds from 'designsystem';
import { Column } from 'hedron';
import styled from 'styled-components';

const labelWidth = '68%';

const Container = styled(Column)`
  position: relative;
  display: flex;
  align-items: flex-start;
  padding-top: ${ds.get('metrics.xs')};
  padding-bottom: ${ds.get('metrics.xs')};
  
  ${({ center }) => (center ? `
    flex-direction: column;
    align-items: center;
  ` : '')}
`;

const Label = styled.p`
  position: relative;
  font-family: ${ds.get('type.fontFamily.text')};
  font-size: ${ds.fs('base')};
  line-height: ${ds.fs('m')};
  color: ${ds.brand('background')};
  width: ${({ labelWide }) => (labelWide ? '100%' : labelWidth)};
  margin-top: ${ds.get('metrics.xs')};
  margin-bottom: calc(${ds.get('metrics.xs')} / 2);
  margin-left: ${ds.get('metrics.xs')};
  
  font-weight: ${({ labelBold }) => (labelBold
    ? ds.get('type.fontWeight.regular')
    : ds.get('type.fontWeight.light')
  )};
  
  ${({ center }) => (center ? `
    width: 100%;
    text-align: center;
    top: -12%;
  ` : '')}
`;

const Value = styled.p`
  font-family: ${ds.get('type.fontFamily.text')};
  font-size: ${ds.fs('l')};
  color: ${ds.brand('background')};
  white-space: nowrap;
  font-weight: ${({ valueBold }) => (valueBold
    ? ds.get('type.fontWeight.regular')
    : ds.get('type.fontWeight.light'))};
  margin: 0;
  
  ${({ center }) => (center ? `
    text-align: center;
    width: ${labelWidth};
  ` : '')};
`;

const Unit = styled.span`
  font-size: ${({ bigUnit }) => (bigUnit ? ds.fs('l') : ds.fs('m'))};
  color: ${ds.brand('background')};
  font-weight: ${({ unitBold }) => (unitBold
    ? ds.get('type.fontWeight.bold')
    : ds.get('type.fontWeight.regular'))};
`;

const Sign = styled.span`
  font-family: ${ds.get('type.fontFamily.text')};
  font-size: ${ds.fs('m')};
  font-weight: ${ds.get('type.fontWeight.bold')};
  color: ${ds.brand('white')};
  margin-right: ${ds.get('metrics.xs')};
  margin-top: calc(${ds.get('metrics.xs')} / 2);
`;

@observer
export default class FullWidthCalculatorDetailsItem extends Component {
  render() {
    const {
      label,
      labelBold,
      value,
      valueBold,
      unit,
      bigUnit,
      unitBold,
      sign,
      center,
    } = this.props;

    return (
      <Container
        center={center}
      >
        {sign && (
          <Sign>
            {sign}
          </Sign>
        )}
        {center && label && (
          <Label
            labelBold={labelBold}
            center
          >
            {label}
          </Label>)
        }
        <Value
          valueBold={valueBold}
        >
          {value.toLocaleString() || value}
          <Unit bigUnit={bigUnit} unitBold={unitBold}>
            {` ${unit}`}
          </Unit>
        </Value>
        {!center && label && (
          <Label
            labelBold={labelBold}
          >
            {`- ${label}`}
          </Label>)
        }
      </Container>
    );
  }
}
FullWidthCalculatorDetailsItem.defaultProps = {
  sign: '',
  bigUnit: false,
  unitBold: false,
  labelBold: false,
  valueBold: false,
  center: false,
};



// WEBPACK FOOTER //
// ./src/kentico-blocks/Calculator/FullWidthCalculatorDetailsItem/index.jsx